
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M4.96951 6.16065c0-2.30083 1.87725-4.2345 4.17202-4.23209.89647.00096 1.72757.28724 2.40767.77292.193.13781.4563.119.6237-.04914l.342-.34374c.1466-.14742.2577-.25919.3434-.3448.2064-.20616.1845-.54824-.0476-.72479C11.7817.456415 10.4982-.00636241 9.10847.0000661 5.7454.0156151 3.04602 2.79798 3.04602 6.16997V9.5H.481355c-.4280976.00004-.642006.5203-.340058.8231L3.6675 13.8588c.18779.1883.4923.1883.68008 0l3.52661-3.5357c.30379-.3046.08575-.8231-.34002-.8231H4.96951V6.16065zM15.2243 6c-.3596 0-.6668.17352-.8716.37851-.2049.205-.3781.51217-.3781.87149l-.0003 2.44947h4.0628V7.25c0-.35952-.1735-.66673-.3784-.87163C17.4538 6.17347 17.1466 6 16.7871 6h-1.5628zM12.9653 12.728c.3234-.3557.6904-.6402 1.0093-.8411L13.9743 11H18.037l.0001.8869c.319.2008.6862.4854 1.0096.8411.4474.4922.8656 1.1827.8654 2.022v9.375c0 .5157-.2514.9791-.5735 1.3013-.3221.3221-.7856.5737-1.3015.5737h-4.0625c-.5158 0-.9792-.2516-1.3013-.5737-.3221-.3221-.5737-.7855-.5737-1.3013V14.75c0-.8393.4182-1.5298.8657-2.022zM22.8585 30.0714c2.2947.0025 4.172-1.9312 4.172-4.2321V22.5h-2.5647c-.4257 0-.6438-.5185-.34-.8231l3.5266-3.5357c.1878-.1883.4923-.1883.6801 0l3.5262 3.5357c.302.3028.088.8231-.3401.8231H28.954v3.33c0 3.372-2.6994 6.1544-6.0625 6.1699-1.3897.0065-2.6732-.4563-3.7022-1.2389-.2321-.1766-.254-.5186-.0476-.7248.0856-.0855.1963-.1968.3427-.3441l.3427-.3444c.1674-.1682.4307-.187.6237-.0492.6801.4857 1.5112.772 2.4077.7729z"}})])
          )
        }
      }
    